import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { Container, ContentWrapper, TextSkeleton } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderHowToUse/__internal__/InsiderHowToUseCardAssets/styled";
import { RoundingStrategy } from "@faire/web--source/common/money";
import { Insider } from "@faire/web--source/slate/icons/InsiderIcon";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Money } from "@faire/web--source/ui/Money";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import React from "react";
import styled from "styled-components";
export var StartSaving = function() {
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsx(ContentWrapper, {
            children: /*#__PURE__*/ _jsxs(Card, {
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Insider, {
                                fontSize: "24px",
                                color: Decorative.shade.teal
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "1x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subheadingSansMedium",
                                color: Decorative.shade.teal,
                                children: "Insider"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(TextSkeleton, {
                        margin: getSpacing(16, 0, 36),
                        width: "226px",
                        stroke: "26px"
                    }),
                    /*#__PURE__*/ _jsx(SavingsSection, {})
                ]
            })
        })
    });
};
var SavingsSection = function() {
    return /*#__PURE__*/ _jsxs(Section, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "Mbz22c",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Your savings with Insider"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displayMSerifRegular",
                children: /*#__PURE__*/ _jsx(Money, {
                    money: IFaireMoney.build({
                        amount_cents: 128900,
                        currency: RetailerStore.get().displayCurrency
                    }),
                    roundingStrategy: RoundingStrategy.DROP_CENTS
                })
            }),
            /*#__PURE__*/ _jsx(TextSkeleton, {
                margin: getSpacing("3x", 0),
                width: "226px",
                stroke: "27px"
            })
        ]
    });
};
var Section = styled.div.withConfig({
    componentId: "sc-43fef495-0"
})([
    "padding:",
    ";border:1px solid ",
    ";border-right:none;border-radius:4px 0px 0px 4px;"
], getSpacing("3x", 0, 0, "4x"), Core.border.muted);
var Card = styled.div.withConfig({
    componentId: "sc-43fef495-1"
})([
    "width:388px;height:347px;padding:",
    ";background-color:",
    ";"
], getSpacing(30, 0, 30, 38), Core.surface.inverse);
